module.exports = __webpack_public_path__ + "media/images/calculator-aki-onco/logo_ge-a79ecb6b60107e744f7148b2ee3d3f5e.svg";